import { useGLTF } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { ObjectLoader } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import 'react';
import './common-DBpCdW70.esm.js';

const MarbleCard = () => {
  const model = useGLTF(defineSrc('marble-card.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('marble-card-light.json'));
  const sphere = model.scene.getObjectByName('Sphere1');
  sphere.material.depthTest = true;
  const stripeBottom = model.scene.getObjectByName('Strip_Center_Big_(4th_-_Bottom_Layer)');
  stripeBottom.material.depthTest = false;
  stripeBottom.renderOrder = 1;
  const stripeLeft = model.scene.getObjectByName('Strip_Left_(3rd)');
  stripeLeft.material.depthTest = false;
  stripeLeft.renderOrder = 2;
  const stripeRight = model.scene.getObjectByName('Strip_Right_(2nd)');
  stripeRight.material.depthTest = false;
  stripeRight.renderOrder = 3;
  const stripeTop = model.scene.getObjectByName('Strip_Center_(1st_-_Top_Layer)');
  stripeTop.material.depthTest = false;
  stripeTop.renderOrder = 4;
  const card = model.scene.getObjectByName('Plane');
  card.material.depthTest = false;
  card.material.metalness = 0;
  const animatedMaps = [sphere, stripeTop, stripeBottom, stripeLeft, stripeRight].map(object => object.material.map);
  useFrame(() => {
    animatedMaps.forEach(map => map.offset.y += -15e-4);
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      scale: 1.4,
      position: [0, -10, 0],
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { MarbleCard as default };
//# sourceMappingURL=MarbleCard-BL4Z4p0q.esm.js.map
